import React from "react";
import { useStoreState } from "easy-peasy";
import "../../../assets/layout/banner.css";
import Parser from 'react-html-parser';
import { FLOW } from "../../../models/websiteTypesConstants";

function GBBanner() {
  const mainSettings = useStoreState(
    (state) => state.siteSettingsModel.mainSettings
  );
  const brandSettings = useStoreState(
    (state) => state.siteSettingsModel.brandSettings
  );
  const productSettings = useStoreState(
    (state) => state.siteSettingsModel.productSettings
  );
  const isPrequal = mainSettings.Flow === FLOW.PREQUAL || mainSettings.Flow === FLOW.REQUALSTRAIGHT;
  const isPrequalStraight = mainSettings.Flow === FLOW.PREQUALSTRAIGHT;
  const isStandalone = mainSettings.Flow === FLOW.STANDALONE;

  const prequalStraightContentStyle = isPrequalStraight
    ? {
        paddingLeft: "30px",
        paddingTop: "22px",
        paddingBottom: "22px",
      }
    : {};
  const prequalStraightTitleStyle = isPrequalStraight
    ? {
        maxWidth: "720px",
        lineHeight: "1.15",
        marginTop: "8px",
        marginBottom: "8px",
      }
    : {};

  return (
    <div>
      <div className={"banner-container banner d-none d-md-block p-0"}>
        <div className="container py-3" style={{maxWidth: "100%", backgroundColor: "#CCECFC"}}>
          <div className="d-flex flex-wrap w-100" style={isPrequalStraight ? {alignItems: "center", minHeight: "450px"} : {}}>
            <div className={"col-lg-1 d-none d-lg-block"}></div>
            <div
              className={"col-md-8 col-lg-6 banner-content"}
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                padding: 0,
                ...prequalStraightContentStyle}}
            >
              <div style={{
                backgroundColor: brandSettings.Primary,
                borderRadius: "24px",
                minWidth: "250px",
                padding: "2em",
                margin: "2em",
              }}
              >
                <div className="row">
                  <h1 className={(!isPrequal && !isStandalone) ? "bannerTextTitle mb-3 mt-3" : "bannerTextTitle"} style={{
                    textAlign: "left",
                    fontSize: "35px",
                    ...prequalStraightTitleStyle
                  }}>
                    {Parser(productSettings.BannerText.Title)}
                  </h1>
                  <h4 className="bannerTextSubtitle">
                    {productSettings.BannerText.SubTitle}
                  </h4>
                </div>
                <div className="row">
                  <ul className={"col-lg-12"}>
                      {productSettings.BannerText.Description.length > 0 && productSettings.BannerText.Description.map((i, j) => {
                        return (
                          <li key={j} className="bannerTextDescription" style={{fontSize: "24px"}}><b>{i.Text}</b></li>
                        );
                      })}
                  </ul>
                </div>
                <div className="row">
                  <div className={ (!isPrequal && !isStandalone) ? "col-lg-12" : "col-lg-6 small"}>
                    <span className="artNotation" style={{fontSize : (!isPrequal && !isStandalone) ? "13px" : ""}}>
                      {productSettings.BannerText.Note}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={"col-md-4 align-self-center small d-flex justify-content-center"}>
              <div className="card-image-container p-0">
                <img alt="" src={brandSettings.CardImage} style={{maxHeight: "320px", width: "auto"}}/>
              </div>
            </div>
            <div className={"col-lg-1 d-none d-lg-block"}></div>
           </div>
        </div>
      </div>
      <div className={"banner-container banner d-sm-block d-md-none"}>
        <div className="container" style={{maxWidth: "100%", padding: 0, paddingTop: "60px", paddingBottom: "60px", backgroundColor: "#CCECFC"}}>
          <div className="d-flex flex-wrap w-100" style={isPrequalStraight ? {alignItems: "center", minHeight: "450px"} : {}}>
            <div className={"col-lg-6 align-self-center small d-flex justify-content-center"}>
              <div className="card-image-container p-0 text-center w-100">
                <img alt="" src={brandSettings.CardImage} className="col-lg-4" style={{maxHeight: "260px", width: "auto"}}/>
              </div>
            </div>
            <div
              className={"col-md-8 banner-content"}
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                padding: 0,
                ...prequalStraightContentStyle}}
            >
              <div style={{
                backgroundColor: brandSettings.Primary,
                borderRadius: "24px",
                minWidth: "250px",
                padding: "2em",
                margin: "2em",
              }}
              >
                <div className="row">
                  <h1 className={(!isPrequal && !isStandalone) ? "bannerTextTitle mb-3 mt-3" : "bannerTextTitle"} style={{
                    textAlign: "left",
                    ...prequalStraightTitleStyle
                  }}>
                    {Parser(productSettings.BannerText.Title)}
                  </h1>
                  <h4 className="bannerTextSubtitle">
                    {productSettings.BannerText.SubTitle}
                  </h4>
                </div>
                <div className="row">
                  <ul className={"col-lg-12"}>
                      {productSettings.BannerText.Description.length > 0 && productSettings.BannerText.Description.map((i, j) => {
                        return (
                          <li key={j} className="bannerTextDescription bold"><b>{i.Text}</b></li>
                        );
                      })}
                  </ul>
                </div>
                <div className="row">
                  <div className={ (!isPrequal && !isStandalone) ? "col-lg-12" : "col-lg-6 small"}>
                    <span className="artNotation" style={{fontSize : (!isPrequal && !isStandalone) ? "13px" : ""}}>
                      {productSettings.BannerText.Note}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GBBanner;
